import React, { useEffect } from "react";
import { X } from "lucide-react";

export default function ProjectModal({ project, onClose }) {
  useEffect(() => {
    if (project) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => {
      window.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [project, onClose]);

  if (!project) return null;

  return (
    <div className="fixed inset-0 z-[60] flex justify-end">
      <div
        className="absolute inset-0 bg-[var(--ink)]/40 backdrop-blur-sm animate-[fadeIn_0.3s_ease]"
        onClick={onClose}
      />
      <div className="relative w-full max-w-2xl h-full bg-[#FAFAF7] overflow-y-auto shadow-2xl animate-[slideIn_0.45s_cubic-bezier(0.16,1,0.3,1)]">
        <div className="sticky top-0 z-10 flex items-center justify-between px-8 py-5 bg-[#FAFAF7]/90 backdrop-blur-md border-b border-[var(--line)]">
          <span className="section-label">{project.category}</span>
          <button
            onClick={onClose}
            className="w-10 h-10 rounded-full border border-[var(--line)] flex items-center justify-center hover:bg-[var(--ink)] hover:text-[#FAFAF7] transition-colors"
            aria-label="Close"
          >
            <X size={18} />
          </button>
        </div>

        <div className="px-8 py-10">
          <h2 className="font-serif-display font-light text-4xl md:text-5xl tracking-[0.015em] leading-tight">
            {project.title}
          </h2>

          <div className="grid grid-cols-3 gap-4 mt-8 pb-8 border-b border-[var(--line)]">
            {[
              ["Client", project.client],
              ["Year", project.year],
              ["Role", project.role],
            ]
              .filter(([, value]) => value)
              .map(([label, value]) => (
                <div key={label}>
                  <p className="section-label mb-1">{label}</p>
                  <p className="text-[15px]">{value}</p>
                </div>
              ))}
          </div>

          <p className="text-[17px] leading-relaxed text-[var(--muted)] mt-8">
            {project.summary}
          </p>

          <div className="mt-8 space-y-5">
            {project.gallery.map((src, i) => (
              <img
                key={i}
                src={src}
                alt={`${project.title} ${i + 1}`}
                className={`w-full rounded-lg bg-[var(--bg-alt)] ${
                  project.blend ? "mix-blend-multiply" : ""
                }`}
              />
            ))}
            <div className="flex items-center justify-center h-40 rounded-lg border border-dashed border-[var(--line)] text-[var(--muted)] text-sm">
              + Add more project images here
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes fadeIn { from { opacity: 0 } to { opacity: 1 } }
        @keyframes slideIn { from { transform: translateX(40px); opacity: 0 } to { transform: translateX(0); opacity: 1 } }
      `}</style>
    </div>
  );
}
